"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFiles = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const snackbar_context_1 = require("../../composite/snackbar/snackbar-context");
const snackbar_types_1 = require("../../composite/snackbar/snackbar-types");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const files_api_1 = require("./files-api");
function useFiles(url, maxUploadSize) {
    const intl = react_intl_1.useIntl();
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const [loading, setLoading] = react_1.useState(false);
    const getFileUrl = event_callback_hook_1.useEventCallback((id) => `${url}/${id}`);
    const uploadFile = event_callback_hook_1.useEventCallback(async (file) => {
        if (maxUploadSize !== undefined) {
            if (file.size > maxUploadSize) {
                const message = intl.formatMessage({
                    id: 'EAS_FILES_MSG_ERROR_UPLOAD_SIZE',
                    defaultMessage: 'Byla překročena maximální povolena velikost souboru',
                });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                throw new Error('Max file size error');
            }
        }
        try {
            const fileRef = await files_api_1.callUploadFile(url, file).json();
            const message = intl.formatMessage({
                id: 'EAS_FILES_MSG_SUCCESS',
                defaultMessage: 'Nahrávaní souboru dokončeno',
            });
            showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
            setLoading(false);
            return fileRef;
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                let message = '';
                if (err.exception ===
                    'class org.springframework.web.multipart.MaxUploadSizeExceededException') {
                    message = intl.formatMessage({
                        id: 'EAS_FILES_MSG_ERROR_UPLOAD_SIZE',
                        defaultMessage: 'Byla překročena maximální povolena velikost souboru',
                    });
                }
                else if (err.exception ===
                    'class cz.inqool.eas.common.exception.VirusFoundException') {
                    message = intl.formatMessage({
                        id: 'EAS_FILES_MSG_ERROR_VIRUS',
                        defaultMessage: 'Soubor nebyl nahrán protože obsahuje virus',
                    });
                }
                else if (err.exception ===
                    'class cz.inqool.eas.common.exception.ExtensionNotAllowedException') {
                    message = intl.formatMessage({
                        id: 'EAS_FILES_MSG_ERROR_NOT_ALLOWED',
                        defaultMessage: 'Soubor nebyl nahrán protože má nepovolenou příponu ',
                    });
                }
                else {
                    message = intl.formatMessage({
                        id: 'EAS_FILES_MSG_ERROR',
                        defaultMessage: 'Chyba nahrávaní souboru: {detail}',
                    }, { detail: err.message });
                }
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                throw err;
            }
        }
    });
    const context = react_1.useMemo(() => ({
        loading,
        url,
        getFileUrl,
        uploadFile,
    }), [loading, url, getFileUrl, uploadFile]);
    return { context };
}
exports.useFiles = useFiles;
//# sourceMappingURL=files-hook.js.map